import React from 'react';
import { Polygon, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

export interface DiamondMarkerProps {
    key: string;
    color: string;
    position: any;
    radius: number;
    fteDVMs: number;
    name: string;
    opacity: number;
    isAnimated: boolean;
    showTooltip: boolean;
    onClick?: (event: any) => void;
}

export const DiamondMarker = (props: DiamondMarkerProps) => {
    const latFactor = 1 / 110540;
    const lngFactor =
        1 / (111320 * Math.cos((props.position[0] * Math.PI) / 180));
    const sizeLat = props.radius * latFactor;
    const sizeLng = props.radius * lngFactor;

    const points = [
        [props.position[0], props.position[1] + sizeLng],
        [props.position[0] + sizeLat, props.position[1]],
        [props.position[0], props.position[1] - sizeLng],
        [props.position[0] - sizeLat, props.position[1]],
    ];
    const handleClick = (event: any) => {
        if (props.onClick) {
            props.onClick(event);
        }
    };
    return (
        <Polygon
            pane="markerPane"
            eventHandlers={{
                click: handleClick,
            }}
            key={`${props.key}-${props.opacity}`}
            positions={points}
            color="transparent"
            weight={0}
            fillColor={props.color}
            fillOpacity={props.opacity}>
            {!props.isAnimated && props.showTooltip && (
                <Tooltip direction="top">
                    FTE DVMs: {props.fteDVMs} | Type: {props.name}
                </Tooltip>
            )}
        </Polygon>
    );
};
